import { render } from "./DownloadButtonWithPopUp.vue?vue&type=template&id=4e6aa728&scoped=true&ts=true"
import script from "./DownloadButtonWithPopUp.vue?vue&type=script&lang=ts"
export * from "./DownloadButtonWithPopUp.vue?vue&type=script&lang=ts"

import "./DownloadButtonWithPopUp.vue?vue&type=style&index=0&id=4e6aa728&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e6aa728"]])

export default __exports__